module.exports = __webpack_public_path__ + "static/media/stabilize.d1cdac66.png";